export default "__VITE_ASSET__DmEWJeYe__"